'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it/index.js
// module id = 2969
// module chunks = 0